var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "own" }, [
    _c(
      "div",
      {
        staticClass: "cf calendar-item",
        class: { active: _vm.active },
        on: {
          click: function ($event) {
            return _vm.load()
          },
        },
      },
      [
        _c("span", {
          staticClass: "bullit",
          style: { backgroundColor: _vm.color },
        }),
        _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.name))]),
        _vm.editable
          ? [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("edit-calendar"),
                      expression: "$ct('edit-calendar')",
                    },
                  ],
                  attrs: { flat: "", right: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("delete-calendar"),
                      expression: "$ct('delete-calendar')",
                    },
                  ],
                  staticClass: "danger",
                  attrs: { flat: "", right: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.remove()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }